import { Component } from '@angular/core';
import { Breadcrumb, Facet, FacetValue, TranslatePipe } from '@spartacus/core';
import { ActiveFacetsComponent, FocusDirective, IconComponent } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-active-facets',
    templateUrl: './efa-active-facets.component.html',
    imports: [
        RouterLink,
        FocusDirective,
        IconComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class EfaActiveFacetsComponent extends ActiveFacetsComponent {
  getVisibleActiveFacets(
    facets: Facet[],
    activeFacets: Breadcrumb[],
  ): Breadcrumb[] {
    const categoryFacet: Facet = facets.find((facet: Facet) => facet.category);

    if (categoryFacet == null) {
      return activeFacets;
    }

    const selectedParentFacetValues: FacetValue[] = categoryFacet.values.filter(
      (facetValue: FacetValue) =>
        this.isSelectedParent(facetValue, categoryFacet.values),
    );

    const visibleActiveFacets: Breadcrumb[] = activeFacets.filter(
      (activeFacet: Breadcrumb) =>
        selectedParentFacetValues.find(
          (facetValue: FacetValue) =>
            activeFacet.facetValueCode === facetValue.code,
        ) == null,
    );

    return visibleActiveFacets;
  }

  private isSelectedParent(
    facetValue: FacetValue,
    facetValues: FacetValue[],
  ): boolean {
    return (
      facetValue.selected &&
      facetValues.find(
        (facetValueFromFacet: FacetValue) =>
          facetValueFromFacet.code.startsWith(facetValue.code) &&
          facetValueFromFacet.code !== facetValue.code &&
          facetValueFromFacet.selected
      ) != null
    );
  }
}
